<template>
  <label class="color-input">
    {{ label }}
    <input
      data-hj-allow
      type="text"
      :name="inputName"
      v-model="internal"
      :placeholder="placeholder"
      maxlength="6"
    />
    <span class="color-input__sample" :style="previewBackgroundColor"></span>
    <span class="error-text" v-for="error in externalErrors" :key="error">{{
      error
    }}</span>
    <p class="help-text">{{ helpText }}</p>
  </label>
</template>

<script>
export default {
  name: 'colorInput',
  props: {
    externalErrors: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: '',
    },
    helpText: {
      type: String,
      default: '',
    },
    inputName: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: 'FFFFFF',
    },
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      internal: this.value,
    };
  },
  computed: {
    previewBackgroundColor() {
      return {
        'background-color': '#' + (this.internal ? this.internal : 'a1a7b3'),
      };
    },
  },
  watch: {
    value() {
      this.internal = this.value.replace('#', '');
      this.$forceUpdate();
    },
    internal() {
      var val = this.internal ? '#' + this.internal : this.internal;
      this.$emit('changeColor', {
        key: this.inputName,
        value: val,
      });
    },
  },
  created() {
    this.internal = this.value.replace('#', '');
    this.$forceUpdate();
  },
};
</script>
